const ClearIbbotsonCacheFactory = [
    "$resource",
    "$window",
    function ($resource) {
        return $resource(
            __baseApiUrl__ +
                "/participant-web-services/rest/investments/services/ibbotsonReturn/:groupId",
            {},
            {
                query: {
                    method: "GET",
                    isArray: false
                }
            }
        );
    }
];
export default ClearIbbotsonCacheFactory;
